import client from './client'
import {
  TicketQueryInfo,
  ListResponse,
  TicketInfo,
  TicketStatus,
  DialogInfo,
  DialogReplyInfo,
  CreateTicket,
  TicketType,
} from '@/types'

export const getTickets = (params: TicketQueryInfo) => {
  return client<ListResponse<TicketInfo>>({
    url: 'tickets',
    method: 'get',
    params,
  })
}

export const getTicketStatus = (id: number) => {
  return client<TicketStatus>({
    url: `tickets/${id}`,
    method: 'get',
  })
}

export const getTicketDialog = (id: number) => {
  return client<ListResponse<DialogInfo> & { state: TicketType }>({
    url: `/tickets/${id}/dialogs`,
    method: 'get',
  })
}

export const repleyDialog = (data: DialogReplyInfo) => {
  return client<unknown>({
    url: `/tickets/${data.id}/dialog`,
    method: 'post',
    data,
  })
}

export const createTicket = (data: CreateTicket) => {
  return client<unknown>({
    url: 'tickets',
    method: 'post',
    data,
  })
}

export const finishTicket = (id: number) => {
  return client<{ id: number }>({
    url: `tickets/${id}`,
    method: 'put',
  })
}

export const closeTicket = (id: number) => {
  return client<{ id: number }>({
    url: `tickets/${id}/closed`,
    method: 'put',
  })
}

export const UploadImage = (file: File) => {
  const formData = new FormData()
  formData.append('images', file)
  return client<{ paths: string }>({
    url: 'tickets/upload',
    method: 'post',
    data: formData,
  })
}
